(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sorveno-article-reader"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sorveno-article-reader')) {
  class SorvenoArticleReader extends HTMLElement {
    connectedCallback() {
      if (this.dataset.readerReady) return;
      this.dataset.readerReady = 'true';
      const headings = Array.from(this.querySelectorAll('.sv-editorial__body h2'));
      const navigation = this.querySelector('[data-article-toc]');
      const aside = this.querySelector('[data-article-navigation]');
      if (!navigation || !aside || headings.length < 2) return;
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = this.id + '-part-' + (index + 1);
        const anchor = document.createElement('a');
        anchor.href = '#' + heading.id;
        anchor.textContent = heading.textContent;
        navigation.appendChild(anchor);
      });
      aside.hidden = false;
      this.dataset.hasContents = 'true';
      const contents = this.querySelector('.sv-editorial__contents');
      const compactView = window.matchMedia('(max-width: 999px)');
      contents.open = !compactView.matches;
      const anchors = Array.from(navigation.querySelectorAll('a'));
      const markActive = heading => {
        anchors.forEach(anchor => {
          if (anchor.hash === '#' + heading.id) anchor.setAttribute('aria-current', 'location');
          else anchor.removeAttribute('aria-current');
        });
      };
      markActive(headings[0]);
      if ('IntersectionObserver' in window) {
        this.readerObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (entry.isIntersecting) markActive(entry.target); });
        }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
        headings.forEach(heading => this.readerObserver.observe(heading));
      }
    }
    disconnectedCallback() {
      if (this.readerObserver) this.readerObserver.disconnect();
    }
  }
  customElements.define('sorveno-article-reader', SorvenoArticleReader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorveno-blog-overview"]) return;
  try {
    
  if (!customElements.get('sorveno-blog-demo')) {
    customElements.define('sorveno-blog-demo', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-demo-filter]');
          if (!button || !this.contains(button)) return;
          const category = button.dataset.demoFilter;
          this.querySelectorAll('[data-demo-filter]').forEach((filter) => {
            const selected = filter === button;
            filter.setAttribute('aria-pressed', String(selected));
            filter.classList.toggle('is-active', selected);
          });
          this.querySelectorAll('[data-demo-category]').forEach((card) => {
            card.hidden = category !== 'all' && card.dataset.demoCategory !== category;
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
